import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
// ---- external imports ----

import { TURN_FETCHED_NEXT } from '~/store/turn/actionTypes';
import { employeesActions } from '~/store/actions';
// ---- internal imports -----

const employeesResetWorkCycleEpic = (action$) => action$.pipe(
	ofType(TURN_FETCHED_NEXT),
	map(employeesActions.resetCustomerEmployeesWorkCycle)
);

export default employeesResetWorkCycleEpic;
